<div class="sb-step sb-step-shipping-method sb-step-sim-type">
  <form class="sb-step__form" [formGroup]="formGroup">

    <!-- region Step container -->
    <div class="sb-step__form__content">
      <div class="sb-step__inner-container">
        <div class="sb-form-block" formGroupName="simType">
          <div class="sb-step-sim-type-title col-sm-8 col-sm-offset-2">
            {{'ENTITY.SIM-TYPE.TITLE' | translate}}
          </div>
          <div class="row radio-container wt-margin-bottom-2" >
            <ng-container *ngFor="let simType of availableSimTypes">
              <div class="col-xs-12 col-sm-8 col-sm-offset-2 wt-margin-bottom-5 radio-box simtype-box" >
                <wt-input-radio groupName="shippingMethod-radio-group" [value]="simType.id" formControlName="type" [isHTML]="true" (click)="onSimTypeChange(simType.id)">
                  <sb-display-input-radio [invalid]="isSimTypeInvalid"
                                          [images]="simType.images"
                                          [lean]="simType.id === 'e-sim' || simType.id === 'standard'"
                                          [title]="simType.title"></sb-display-input-radio>
                  <div *ngIf="simType.id === 'e-sim' || simType.id === 'standard'">
                    <span class="simtype-box-description" [innerHTML]="'ENTITY.SIM-TYPE.' + simType.id.toUpperCase() + '.DESCRIPTION' | translate"></span>
                  </div>
                </wt-input-radio>
              </div>
            </ng-container>
          </div>
          <div class="row">
            <div class="col-xs-12 col-sm-8 col-sm-offset-2 wt-margin-bottom-4 sb-step-sim-type-footer-text">
              Dubbi sulla eSIM? Scopri i <a class="wt-link" (click)="simTypeGenericpopup()">suoi vantaggi</a> e i <a class="wt-link device-list-modalurl" (click)="showCompatibleDevices()" tabindex="0" (keyup.Space)="showCompatibleDevices()">dispositivi compatibili</a>.
            </div>
            <!-- <div class="col-xs-12 col-sm-8 col-sm-offset-2" *ngIf="formGroup.get('simType.type').value === 'e-sim'">
              <form [formGroup]="simTypeESIMForm">
                <wt-input-checkbox formControlName="confirm">Ho un dispositivo compatibile con l’eSIM.</wt-input-checkbox>
              </form>
            </div> -->
          </div>

          <!-- endregion -->
        </div>
      </div>
    </div>
    <!-- endregion -->
    <section class="sb-step__form__footer">
      <sb-navigation-buttons [isStickyHide]="false" [isSticky]="shouldBeSticky" [submitDisabled]="this.formGroup.invalid || this.simTypeESIMForm.invalid" (backClick)="goToPreviousStep()" (submitClick)="goToNextStep()"></sb-navigation-buttons>
    </section>
  </form>
</div>
